import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import("./containers/DefaultContainer");

// Views
const Dashboard = () => import("./views/Dashboard");
// const User = () => import('./views/users/UserProfile')
// const UserSettings = () => import('./views/users/UserSettings')
const UserPanel = () => import('./views/users/UserPanel');

//SOPORTE SERIES
const Series = () => import('./views/seriesSoporte/seriesSoporte');
// Vistas general de Comprobantes
const Factura = () => import('./views/factura/Factura');
const Boleta = () => import('./views/boleta/Boleta');
const NotaCredito = () => import('./views/notacredito/NotaCredito');
const NotaDebito = () => import('./views/notadebito/NotaDebito');
const Guia = () => import('./views/guiaremision/GuiaRemision');
const Baja = () => import('./views/comunicacionbaja/ComunicacionBaja');
const CargaMasiva = () => import('./views/cargamasiva/cargarDocumentos');
const Producto = () => import('./views/producto/Producto');
const Proforma = () => import ('./views/proforma/Proforma');
const Percepcion = () => import ('./views/percepcion/Percepcion');
const Market = () => import ('./views/market/Market');
const Caja = () => import ('./views/caja/Ordenpago');

/**********/ 
const Stock = () => import('./views/ingresoStock/registroStock');
/***********/ 
// Vista general de Reportes
const ReportesGenerales = () => import('./views/reportes/Reportes');
// const FacturaReporte = () => import('./views/factura/FacturaReporte')
// const BoletaReporte = () => import('./views/boleta/BoletaReporte')
// const NotaCreditoReporte = () => import('./views/notacredito/NotaCreditoReporte')
// const NotaDebitoReporte = () => import('./views/notadebito/NotaDebitoReporte')
// const GuiaRemisionReporte = () => import('./views/guiaremision/GuiaRemisionReporte')
// Modulo de gestion 
const Terceros = () => import('./views/gestion/Terceros');
const Cobranzas = () => import('./views/gestion/Cobranzas');
const Pagos = () => import('./views/gestion/PagosCobranza');
const Pedidos = () => import('./views/gestion/Pedidos');

//personal
//const Personal = () => import('./views/gestion/Personal')
const Colaborador = () => import('./views/gestion/Colaborador');
const nuevoPersonal = () => import('./components/gestion/NuevoPersonal');
const detallePersonal = () => import('./components/gestion/DetallePersonal');
//const DetallePersonal = () => import('./views/gestion/DetallePersonal')

Vue.use(Router);

export default new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/emision/factura",
      name: "Home",
      component: DefaultContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard
        },
        {
          path: "emision",
          name: "Emision",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "factura",
              name: "Factura",
              component: Factura
            },
            {
              path: "boleta",
              name: "Boleta",
              component: Boleta
            },
            {
              path: "seriesSoporte",
              name: "seriesSoporte",
              component: Series
            },
            {
              path: "notacredito",
              name: "NotaCredito",
              component: NotaCredito
            },
            {
              path: "notadebito",
              name: "NotaDebito",
              component: NotaDebito
            },
            {
              path: "guia",
              name: "Guia",
              component: Guia
            },
            {
              path: "baja",
              name: "Baja",
              component: Baja
            },
            {
              path: "cargamasiva",
              name: "CargaMasiva",
              component: CargaMasiva
            },
            {
              path: "proforma",
              name: "Proforma",
              component: Proforma
            },
            {
              path: "percepcion",
              name: "Percepcion",
              component: Percepcion
            },
            {
              path: "market",
              name: "Market",
              component: Market
            }
          ]
        },
        {
          path: "reportes",
          name: "Reportes",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "generales",
              name: "Generales",
              component: ReportesGenerales
            },
            // {
            //   path: "facturas",
            //   name: "Facturas",
            //   component: FacturaReporte
            // },
            // {
            //   path: "boletas",
            //   name: "Boletas",
            //   component: BoletaReporte
            // },
            // {
            //   path: "nota-credito",
            //   name: "Nota Credito",
            //   component: NotaCreditoReporte
            // },
            // {
            //   path: "nota-debito",
            //   name: "Nota Debito",
            //   component: NotaDebitoReporte
            // },
            // {
            //   path: "guia-remision",
            //   name: "Guia Remision",
            //   component: GuiaRemisionReporte
            // }
          ]
        },
        {
          path:"caja",
          name:"Caja",
          component:{
            render(c){
              return c("router-view");
            }
          },
          children: [
            {
              path: "Ordenpago",
              name: "Ordenpago",
              component: Caja
            }
          ]
        },
        {
          path:"stock",
          name:"Stock",
          component:{
            render(c){
              return c("router-view");
            }
          },
          children: [
            {
              path: "stocks",
              name: "Stocks",
              component: Stock
            }
          ]
        },

        {
          path: "modulo",
          name: "Producto",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "productos",
              name: "Productos",
              component: Producto
            }
          ]
        },
        {
          path: "gestion",
          name: "Gestion",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "clientes",
              name: "Clientes",
              component: Terceros
            },
            // {
            //   path: "personal",
            //   name: "Personal",
            //   component: Personal
            // },
            {
              path: "personal",
              name: "Colaborador",
              component: Colaborador
            },
            {
              path: "personalnuevo",
              name: "nuevoPersonal",
              component: nuevoPersonal
            },
            {
              path: "personal/:id",
              name: "DetallePersonal",
              component: detallePersonal
            },
            {
              path: "proveedores",
              name: "Proveedores",
              component: Terceros
            },
            {
              path: "cobranzas",
              name: "Cobranzas",
              component: Cobranzas
            },
            {
              path: "pagos",
              name: "Pagos",
              component: Pagos
            },
            {
              path: "pedidos",
              name: "Pedidos",
              component: Pedidos
            }
          ]
        },
        {
          path: "Panel",
          name: "Panel",
          component: UserPanel
        },
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("./views/Login.vue")
    },
  ]
});
